// extracted by mini-css-extract-plugin
export const wrapper = "footer-module--wrapper--7Flzi";
export const content = "footer-module--content--1Vev3";